(ns quuppa.qsm.cors.view
  (:require [linked.core :as l]
            ["react" :as react]
            [re-frame.core :as rf]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.peweb.query :as q]
            [quuppa.peweb.tables :as tables]
            [quuppa.qsm.cors.events :as e]
            quuppa.qsm.api-keys.subs
            [quuppa.routing :refer [use-subscriptions]]
            [quuppa.ui.layout :as layout]))

(defn new-origin [{:keys [qpe-subscribe qpe-dispatch]}]
  (let [{origin-comment :comment :keys [origin] :as form} @(qpe-subscribe [:qpe/data :ui :sidebar :form])
        error @(qpe-subscribe [:qpe/data :ui :sidebar :error])]
    [layout/sidebar
     [layout/sidebar-header
      {:title "Create origin"
       :on-close #(qpe-dispatch [:qpe/close-sidebar])}]

     [layout/sidebar-content
      [:p "Create origin for API usage"]

      (let [e (-> error :ex-data :malli-error :origin first)]
        [:div.form-group
         [:label
          "Origin"
          [:a {:href "https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Origin"
               :target "new"}
           "(?)"]
          ":"]
         [:input.form-control
          {:value     origin
           :on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :form :origin] (.. % -target -value)])
           :class [(when e "is-invalid")]}]
         (when e
           [:p.form-text.text-danger e])

         [:p.mt-3.form-text.text-muted
          "The wildcard '*' is not supported because the API uses authentication."]])

      (let [e (-> error :ex-data :malli-error :comment first)]
        [:div.form-group
         [:label
          "Comment:"]
         [:textarea.form-control
          {:value     origin-comment
           :on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :form :comment] (.. % -target -value)])
           :class [(when e "is-invalid")]}]
         (when e
           [:p.form-text.text-danger e])])

      [:button.btn.btn-primary
       {:on-click #(qpe-dispatch [:cors/create-origin form])}
       "Create"]

      ;; Display full error if we have other errors than cors_origin
      ;; validation error.
      (when (-> error :ex-data :malli-error (dissoc :origin :comment) seq)
        [:div.alert.alert-danger
         [c/error-alert error]])]]))

(def cors-columns
  (l/map
    :origin
    {:value-fn :origin
     :sortable true
     :width "15%"
     :label "Origin"}

    :comment
    {:value-fn :comment
     :width "45%"
     :sortable false
     :label "Comment"}

    :created-at
    {:value-fn :created-at
     :sortable true
     :width "15%"
     :label "Created at"}

    :created-by
    {:value-fn :created-by
     :sortable true
     :width "15%"
     :label "Created by"}

    :actions
    {:value-fn :actions
     :sortable false
     :width "10%"
     :label "Actions"}))

(rf/reg-sub
  ::sorted-origins
  (fn [[_ qpe-identity]]
    (q/subscribe e/cors-origins-query {:qpe-identity qpe-identity} [:result]))
  (fn [data [_ _qpe-identity sort-key sort-order]]
    (let [column (get cors-columns sort-key)]
      (sort-by (:value-fn column)
               (if sort-order compare #(compare %2 %1))
               data))))

(defn view [{:keys [qpe-dispatch qpe-identity] :as _opts} owner-or-admin?]
  (let [[sort-key set-sort-key] (react/useState :origin)
        [sort-order-asc set-sort-order-asc] (react/useState false)
        sorted-origins @(rf/subscribe [::sorted-origins qpe-identity sort-key sort-order-asc])]
    (react/useEffect (fn []
                       (q/execute e/cors-origins-query {:qpe-identity qpe-identity})
                       (fn []))
                     #js [qpe-identity])
    (use-subscriptions (when qpe-identity
                         [[:cors/add-origin {:qpe-identity qpe-identity}]
                          [:cors/remove-origin {:qpe-identity qpe-identity}]])
                       #js [qpe-identity])
    [:<>
     [:div.d-flex.align-items-center.my-2
      [:h2.flex-grow-1 "CORS origins"]
      (when owner-or-admin?
        [:button.btn.btn-primary
         {:on-click #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar] {:type :new-origin}])}
         "Create origin"])]

     [:table.table.table-striped.table-bordered
      [tables/thead
       {:columns cors-columns
        :sort-key sort-key
        :sort-order-asc sort-order-asc
        :toggle-sort-order (fn [] (set-sort-order-asc not))
        :set-sort-key (fn [k]
                        (set-sort-order-asc true)
                        (set-sort-key k))}]
      [:tbody
       (for [origin sorted-origins]
         ^{:key (:id origin)}
         [:tr
          [:td (:origin origin)]
          [:td (:comment origin)]
          [:td (date-time/format-instant (:created-at origin))]
          [:td (:created-by origin)]
          [:td.text-right
           [:button.btn.btn-primary
            {:on-click (fn [_e]
                         (when (js/confirm "Are you sure?")
                           (qpe-dispatch [:cors/remove-origin-command (:id origin)])))}
            "Remove"]]])]]]))

(def controller
  {:id :api-keys
   :parameters {:path [:qpe-identity]}})
